<script setup lang="ts">
import { Link, useForm } from "@inertiajs/vue3";
import axios from "axios";
import { ref } from "vue";

import Btn from "@/components/ui/atoms/Btn.vue";
import Input from "@/components/ui/atoms/Input.vue";
import PillContainer from "@/components/ui/atoms/PillContainer.vue";
import { resolveUrl } from "@/utils/urls";

const recoveryMessage = ref(false);

const recoverySubmit = () => {
  form.processing = true;
  axios
    .post(resolveUrl("account_recovery"), form.data())
    .then((response) => {
      form.processing = false;
      if (response.data.success) {
        form.reset();
        recoveryMessage.value = true;
      }
    })
    .catch((error) => {
      form.processing = false;
      form.errors = error.response.data.errors;
    });
};

const form = useForm({
  email: null,
});
</script>

<template>
  <div class="recovery" v-if="!recoveryMessage">
    <img class="recovery__brand" src="@img/mm-letter.svg" alt="Mastermind" />
    <h2 class="recovery__title">PROBLEMAS DE ACCESO</h2>
    <h3 class="recovery__subtitle">Introduce tu email para acceder a su cuenta</h3>
    <form @submit.prevent="recoverySubmit">
      <PillContainer full-width :class="'recovery__psw-container'" no-padding>
        <Input
          v-model="form.email"
          required
          type="email"
          placeholder="Email"
          size="medium"
          theme="dark-bold"
          shape="square"
          :class="[{ error: Object.keys(form.errors).length }]"
          high
          full-width
        />
        <Btn
          tag="button"
          type="submit"
          theme="green-bold"
          shape="round"
          :class="['input-submit', { 'input-submit-loading': form.processing }]"
          full-width
          :disabled="form.processing"
        />
        <span v-if="form.errors.email" class="error">{{ form.errors.email }}</span>
      </PillContainer>
    </form>
    <PillContainer full-width :class="['recovery__links']" no-padding>
      <a @click="$emit('recovery')">Entrar</a>
      <Link href="/precios">¿Sin cuenta? Suscríbete ya</Link>
    </PillContainer>
  </div>
  <div class="recovery--message" v-if="recoveryMessage">
    <img class="recovery__brand" src="@img/mm-letter.svg" alt="Mastermind" />
    <h2 class="recovery__title">TRANQUI, YA VAMOS</h2>
    <h3 class="recovery__subtitle">
      Revisa tu bandeja de entrada y spam, te hemos enviado un email con los pasos para
      restablecer tu contraseña.
    </h3>
    <PillContainer full-width :class="['recovery__links']" no-padding>
      <a @click="$emit('recovery')">Volver</a>
    </PillContainer>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/settings/vars";

.recovery {
  &__psw-container {
    position: relative;
  }

  &__brand {
    margin: 24px 0;
  }

  &__title {
    margin-bottom: 8px;
  }

  &__subtitle {
    margin-top: 0;
  }

  &__links {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;

    a {
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
